<ng-container *ngIf="banner$ | async as data">
  <ng-container *ngIf="data.urlLink?.length; else noLink">
    <cx-generic-link [url]="data.urlLink" [target]="data.external ? '_blank' : null" (click)="onBannerClick()">
      <sd-banner-content
        [responsiveBannerData]="data"
        [sdInViewport]="0.5"
        [intersectedOnce]="true"
        (intersected)="onBannerIntersect()"
      ></sd-banner-content>
    </cx-generic-link>
  </ng-container>
  <ng-template #noLink>
    <sd-banner-content [responsiveBannerData]="data" [useGallery]="true"></sd-banner-content>
  </ng-template>
</ng-container>
